//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import {
  getIncorporateMatterById,
  updateIncorporateMatter,
  // ⭐ เพิ่มใหม่ — ลบไฟล์ Foreign Business เดี่ยวทันที ไม่ต้องรอกด Save
  deleteIncorporateMatterForeignBusinessFile,
} from "@/services/api-dtime/api_incorporate";
import { getAllCustomerListByCompany } from "@/services/api-dtime/api_customer";

// ✅ ไฟล์ incorporate อยู่ที่ production storage port 3001
const INCORPORATE_MATTER_FILE_URL = process.env.VUE_APP_PRODUCTION_STORAGE_URL
  ? `${process.env.VUE_APP_PRODUCTION_STORAGE_URL}/incorporatematter`
  : "http://localhost:3001/incorporatematter";

export default {
  name: "incorporate-matter-edit",
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      matterId: null,
      pageLoading: true,
      loadingSave: false,
      activeShareholderIndex: null,
      clientList: [],
      selectedClient: null,
      // ⭐ เพิ่มใหม่ — เก็บรายการ docket ของ matter นี้ เพื่อเช็คว่าควร disable
      // ช่อง Client Name หรือไม่ (ถ้ามี docket แล้วห้ามแก้ไขชื่อลูกค้า)
      dockets: [],
      // ⭐ เพิ่มใหม่ — เก็บ id ของไฟล์ Foreign Business ที่กำลังลบอยู่ (โหลด spinner ปุ่มลบ)
      deletingFileId: null,

      // ✅ เพิ่ม: validation rule สำหรับฟิลด์ที่ label มีเครื่องหมาย * (บังคับกรอก)
      rules: {
        required: (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "กรุณากรอกข้อมูล",
      },

      form: {
        client_id: null,
        client_name: "",
        client_name_en: "",
        entity_type: "",
        status: "Active",
        // individual
        id_type: "national_id",
        full_name: "",
        nationality: "",
        national_id: "",
        passport_no: "",
        contact_address: "",
        contact_number: "",
        contact_email: "",
        // company
        company_name: "",
        registration_no: "",
        date_of_incorporation: "",
        registered_address: "",
        branch: "",
        authority_directors_detail: "",
        registered_capital: 0,
        number_of_shares: 0,
        par_value_per_share: 0,
        paid_up_capital: 0,
        shareholders: [],
        directors: [],
        audit_firm: "",
        licensed_auditor_name: "",
        auditor_license_no: "",
        fiscal_year_start: "",
        fiscal_year_end: "",
        auditor_national_id: "",
        accountant_firm: "",
        accountant_name: "",
        accountant_national_id: "",
        vat_issued_on: "",
        is_foreign_business: false,
        // ── Foreign Business files (⭐ เปลี่ยนเป็นหลายไฟล์ต่อประเภท) ──
        // รายการไฟล์เดิมที่มีอยู่แล้วใน DB (จาก table incorporate_matter_foreign_business_file)
        // แต่ละ item: { id, file_type, file_name, original_name }
        fbl_existing_list: [],
        fbc_existing_list: [],
        // ไฟล์ใหม่ที่เลือกเพิ่ม (ยังไม่ได้ Save) — array ของ File object
        fbl_new_files: [],
        fbc_new_files: [],
      },

      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",
    };
  },
  computed: {
    isIndividual() {
      return this.form.entity_type === "Individual";
    },
    entityTypeLabel() {
      const map = {
        "Limited Company": "Limited Company | บริษัทจำกัด",
        "Public Company Limited": "Public Company Limited | บริษัทมหาชนจำกัด",
        Foundation: "Foundation | มูลนิธิ",
        "Representative Office": "Representative Office | สำนักงานผู้แทนการค้า",
        Individual: "Individual | บุคคลธรรมดา",
      };
      return map[this.form.entity_type] || this.form.entity_type;
    },
    // ⭐ เพิ่มใหม่ — true เมื่อ matter นี้มี docket ผูกอยู่แล้ว (ห้ามแก้ client name)
    hasDockets() {
      return Array.isArray(this.dockets) && this.dockets.length > 0;
    },
    totalOrdinaryShares() {
      return this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0,
      );
    },
    totalPreferredShares() {
      return this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.preferred_shares) || 0),
        0,
      );
    },
    isOrdinarySharesExceeded() {
      return (
        Number(this.form.number_of_shares) > 0 &&
        this.totalOrdinaryShares > Number(this.form.number_of_shares)
      );
    },
    ownershipPercentages() {
      const base = Number(this.form.number_of_shares) || 0;
      const n = this.form.shareholders.length;
      if (!base || !n) return this.form.shareholders.map(() => 0);

      const SCALE = 100000;
      const raw = this.form.shareholders.map(
        (sh) => ((Number(sh.ordinary_shares) || 0) / base) * 100 * SCALE,
      );

      const floors = raw.map((r) => Math.floor(r));
      const target = Math.round(raw.reduce((a, b) => a + b, 0));
      let remainder = target - floors.reduce((a, b) => a + b, 0);

      const order = raw
        .map((r, i) => ({ i, frac: r - Math.floor(r) }))
        .sort((a, b) => b.frac - a.frac || a.i - b.i);

      const units = floors.slice();
      for (let k = 0; k < remainder; k++) {
        units[order[k % n].i] += 1;
      }

      return units.map((u) => u / SCALE);
    },
    totalPercentage() {
      return this.ownershipPercentages.reduce((a, b) => a + b, 0);
    },

  },
  watch: {
    "form.number_of_shares"() {
      if (this.pageLoading) return;
      this.clampOrdinaryShares();
    },
    "form.shareholders": {
      deep: true,
      handler() {
        if (this.pageLoading) return;
        this.clampOrdinaryShares();
      },
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
    this.matterId = this.$route.params.id;
    await this.loadClients();
    await this.loadMatter();
    this.pageLoading = false;
  },
  methods: {
    formatPercent(v) {
      return (Number(v) || 0).toFixed(5) + "%";
    },
    clampOrdinaryShares() {
      if (this._adjusting) return;
      if (!this.form.shareholders.length) return;

      const numShares = Number(this.form.number_of_shares) || 0;
      const total = this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0,
      );

      if (numShares === 0) {
        if (total > 0) {
          clearTimeout(this._zeroResetTimer);
          this._zeroResetTimer = setTimeout(() => {
            this._adjusting = true;
            this.form.shareholders.forEach((sh) => {
              sh.ordinary_shares = 0;
            });
            this.$nextTick(() => {
              this._adjusting = false;
            });
            this.setupAlertDialog(
              true,
              "แจ้งเตือน",
              "Number of Shares เป็น 0 — ระบบได้ปรับ Ordinary Shares ของผู้ถือหุ้นทุกคนกลับเป็น 0 กรุณากรอก Number of Shares ก่อน",
              "text-h5 orange--text text-center",
            );
          }, 800);
        }
        return;
      }

      clearTimeout(this._zeroResetTimer);

      if (total <= numShares) return;

      // ⭐ ปรับ "แถวที่ผู้ใช้เพิ่งแก้" (จาก @focus) ถ้าไม่มีให้ fallback เป็นแถวสุดท้าย
      // เช่น กรณีแก้ Number of Shares ให้น้อยลงจนตารางเดิมเกิน
      const idx =
        this.activeShareholderIndex !== null &&
          this.activeShareholderIndex < this.form.shareholders.length
          ? this.activeShareholderIndex
          : this.form.shareholders.length - 1;

      this._adjusting = true;
      const targetRow = this.form.shareholders[idx];
      const othersTotal = total - (Number(targetRow.ordinary_shares) || 0);
      const adjusted = Math.max(numShares - othersTotal, 0);
      targetRow.ordinary_shares = adjusted;
      this.$nextTick(() => {
        this._adjusting = false;
      });

      this.setupAlertDialog(
        true,
        "แจ้งเตือน",
        `ผลรวม Ordinary Shares เกิน Number of Shares (${numShares}) — ระบบได้ปรับค่าแถวที่ ${idx + 1} เป็น ${adjusted} ให้อัตโนมัติ`,
        "text-h5 orange--text text-center",
      );
    },

    async loadClients() {
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getAllCustomerListByCompany(company_id);
        // ✅ FIX: แปลง id เป็น Number เพื่อให้ === match กับ client_id จาก matter
        this.clientList = (res.data || []).map((c) => ({
          text: c.customer_name || c.name || `Customer #${c.id}`,
          value: Number(c.id),
        }));
      } catch (error) {
        console.error("Error loading clients:", error);
      }
    },

    async loadMatter() {
      try {
        const res = await getIncorporateMatterById(this.matterId);
        const m = res.data;

        // Map data → form
        Object.keys(this.form).forEach((key) => {
          if (m[key] !== undefined && m[key] !== null) {
            this.form[key] = m[key];
          }
        });

        // Shareholders & Directors
        this.form.shareholders = (m.shareholders || []).map((sh) => ({
          full_name: sh.full_name || "",
          nationality: sh.nationality || "",
          ordinary_shares: sh.ordinary_shares || 0,
          preferred_shares: sh.preferred_shares || 0,
        }));
        this.form.directors = (m.directors || []).map((dir) => ({
          full_name: dir.full_name || "",
          nationality: dir.nationality || "",
          authorized: dir.authorized || "",
        }));

        // ⭐ เก็บรายการ docket — ใช้เช็คว่าควร disable ช่อง Client Name หรือไม่
        this.dockets = m.dockets || [];

        // ⭐ เก็บรายการไฟล์ Foreign Business หลายไฟล์ (จาก table ใหม่)
        // backend ส่ง m.foreign_business_files = [{ id, file_type, file_name, original_name }, ...]
        const allFbFiles = m.foreign_business_files || [];
        this.form.fbl_existing_list = allFbFiles.filter(
          (f) => f.file_type === "license",
        );
        this.form.fbc_existing_list = allFbFiles.filter(
          (f) => f.file_type === "certificate",
        );

        // ⭐ Backward-compat: ถ้า matter เก่าไม่มีข้อมูลใน table ใหม่เลย
        // (ยังไม่เคยถูก migrate) แต่มีไฟล์เดิมในคอลัมน์เก่า ให้แสดงเป็นไฟล์
        // เดี่ยวในรายการไปก่อน (id ใช้ string พิเศษเป็น sentinel เพื่อไม่ชน
        // กับ id จริงที่ backend ส่งมาเป็น integer ปกติ)
        if (
          this.form.fbl_existing_list.length === 0 &&
          m.foreign_business_license_file
        ) {
          this.form.fbl_existing_list.push({
            id: "legacy-fbl",
            file_type: "license",
            file_name: m.foreign_business_license_file,
            original_name: m.foreign_business_license_file,
          });
        }
        if (
          this.form.fbc_existing_list.length === 0 &&
          m.foreign_business_certificate_file
        ) {
          this.form.fbc_existing_list.push({
            id: "legacy-fbc",
            file_type: "certificate",
            file_name: m.foreign_business_certificate_file,
            original_name: m.foreign_business_certificate_file,
          });
        }

        this.form.fbl_new_files = [];
        this.form.fbc_new_files = [];

        // Set selected client ใน autocomplete
        // ใช้ $nextTick เพื่อรอให้ clientList render ใน v-autocomplete ก่อน
        if (m.client_id || m.client_name) {
          this.$nextTick(() => {
            const found = this.clientList.find(
              (c) => c.value === Number(m.client_id),
            );
            if (found) {
              this.selectedClient = found;
            } else if (m.client_name) {
              // ไม่เจอใน list → สร้าง object ชั่วคราวให้แสดงชื่อได้
              this.selectedClient = { text: m.client_name, value: m.client_id };
            }
          });
        }
      } catch (error) {
        console.error("Error loading matter:", error);
      }
    },

    // ── File helper methods ──
    getFileUrl(filename) {
      return `${INCORPORATE_MATTER_FILE_URL}/${this.matterId}/${filename}`;
    },
    isPdf(filename) {
      return filename?.toLowerCase().endsWith(".pdf");
    },

    // ⭐ เปลี่ยนเป็นรองรับหลายไฟล์ — เลือกแล้ว push เข้า array ที่จะอัปโหลดตอน Save
    onFblFileChange(e) {
      const files = Array.from(e.target.files || []);
      this.form.fbl_new_files.push(...files);
      e.target.value = "";
    },
    onFbcFileChange(e) {
      const files = Array.from(e.target.files || []);
      this.form.fbc_new_files.push(...files);
      e.target.value = "";
    },
    // ⭐ ลบไฟล์ใหม่ที่ยังไม่ได้ Save ออกจากรายการ (ตาม index)
    clearNewFile(type, idx) {
      if (type === "fbl") this.form.fbl_new_files.splice(idx, 1);
      if (type === "fbc") this.form.fbc_new_files.splice(idx, 1);
    },
    // ⭐ ลบไฟล์เดิม (ที่บันทึกแล้วใน DB) ทันทีผ่าน API — ไม่ต้องรอกด Save
    async deleteExistingForeignBusinessFile(file) {
      if (
        !confirm(
          `ต้องการลบไฟล์ "${file.original_name || file.file_name}" หรือไม่?`,
        )
      )
        return;

      this.deletingFileId = file.id;
      try {
        if (String(file.id).startsWith("legacy-")) {
          // ไฟล์ legacy (จากคอลัมน์เก่า ยังไม่มี id จริงใน table ใหม่)
          // ลบโดยอัปเดตคอลัมน์เก่าให้เป็น null ผ่าน endpoint update ปกติ
          const fd = new FormData();
          if (file.file_type === "license")
            fd.append("fbl_clear_legacy", "true");
          if (file.file_type === "certificate")
            fd.append("fbc_clear_legacy", "true");
          await updateIncorporateMatter(this.matterId, fd);
        } else {
          await deleteIncorporateMatterForeignBusinessFile(
            this.matterId,
            file.id,
          );
        }

        if (file.file_type === "license") {
          this.form.fbl_existing_list = this.form.fbl_existing_list.filter(
            (f) => f.id !== file.id,
          );
        } else {
          this.form.fbc_existing_list = this.form.fbc_existing_list.filter(
            (f) => f.id !== file.id,
          );
        }
      } catch (error) {
        console.error("Error deleting foreign business file:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการลบไฟล์",
          "text-h5 red--text text-center",
        );
      } finally {
        this.deletingFileId = null;
      }
    },

    onClientChange(selected) {
      if (selected && selected.value) {
        this.form.client_id = selected.value;
        this.form.client_name = selected.text;
        if (!this.isIndividual) {
          this.form.company_name = selected.text; // ⭐ auto-fill Company Name จาก Client ที่เลือก
        }
      } else {
        this.form.client_id = null;
        this.form.client_name = "";
      }
    },

    onClientClear() {
      this.selectedClient = null;
      this.form.client_id = null;
      this.form.client_name = "";
      if (!this.isIndividual) {
        this.form.company_name = ""; // ⭐ เคลียร์ Company Name ด้วยเมื่อ clear client
      }
    },

    addShareholder() {
      this.form.shareholders.push({
        full_name: "",
        nationality: "",
        ordinary_shares: 0,
        preferred_shares: 0,
      });
    },
    removeShareholder(i) {
      this.form.shareholders.splice(i, 1);
      this.activeShareholderIndex = null;   // ⭐ กัน index ค้างชี้ไปแถวที่ไม่มีแล้ว
    },
    addDirector() {
      this.form.directors.push({
        full_name: "",
        nationality: "",
        authorized: "",  // ⭐ เปลี่ยนจาก "-- เลือก --" เป็นค่าว่าง (ยังไม่ได้เลือก)
      });
    },
    removeDirector(i) {
      this.form.directors.splice(i, 1);
    },

    // ⭐ แก้ไข — เพิ่ม helper กลาง formatThaiNationalId() + method ผูกกับ
    // ทั้ง 3 ฟิลด์เลข 13 หลัก (national_id, auditor_national_id,
    // accountant_national_id) แบบเดียวกับที่แก้ไว้ใน IncorporateMatterAdd.vue
    // เพื่อให้พิมพ์ได้เฉพาะตัวเลขและขึ้นขีดคั่นอัตโนมัติ
    // (รูปแบบ X-XXXX-XXXXX-XX-X) — เดิมไฟล์ Edit นี้ไม่มี logic กรองเลย
    // แม้แต่ฟิลด์เดียว มีแค่ maxlength="17" เฉย ๆ
    formatThaiNationalId(rawValue) {
      let d = (rawValue || "").replace(/\D/g, "").slice(0, 13);
      let result = d;
      if (d.length > 1) result = d[0] + "-" + d.slice(1);
      if (d.length > 5)
        result = result.slice(0, 2) + d.slice(1, 5) + "-" + d.slice(5);
      if (d.length > 10)
        result =
          result.slice(0, 12) + "-" + d.slice(10, 12) + "-" + d.slice(12);
      return result;
    },

    formatNationalId() {
      this.form.national_id = this.formatThaiNationalId(this.form.national_id);
    },

    formatAuditorNationalId() {
      this.form.auditor_national_id = this.formatThaiNationalId(
        this.form.auditor_national_id,
      );
    },

    formatAccountantNationalId() {
      this.form.accountant_national_id = this.formatThaiNationalId(
        this.form.accountant_national_id,
      );
    },

    // ✅ เพิ่ม: validateForm() — ไฟล์ Edit เดิมไม่มีการตรวจสอบฟิลด์บังคับก่อน Save
    validateForm() {
      if (this.isIndividual) {
        if (!this.form.client_name || !this.form.client_name.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Client Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (this.form.id_type === "national_id") {
          if (!this.form.national_id || !this.form.national_id.trim()) {
            this.setupAlertDialog(
              true,
              "Check information",
              "กรุณากรอกเลขบัตรประชาชน (13 หลัก)",
              "text-h5 red--text text-center",
            );
            return false;
          }
        } else {
          if (!this.form.passport_no || !this.form.passport_no.trim()) {
            this.setupAlertDialog(
              true,
              "Check information",
              "กรุณากรอกเลขที่หนังสือเดินทาง",
              "text-h5 red--text text-center",
            );
            return false;
          }
        }
      } else {
        if (!this.form.company_name || !this.form.company_name.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Company Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (!this.form.registration_no || !this.form.registration_no.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Registration No.",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (
          !this.form.registered_address ||
          !this.form.registered_address.trim()
        ) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Registered Address",
            "text-h5 red--text text-center",
          );
          return false;
        }
      }
      return true;
    },

    buildFormData() {
      const fd = new FormData();
      const user_id = localStorage.getItem(server.USER_ID);

      if (this.form.client_id) fd.append("client_id", this.form.client_id);

      const fields = [
        "client_name",
        "client_name_en",
        "entity_type",
        "nationality",
        "status",
        "registration_no",
        "company_name",
        "date_of_incorporation",
        "registered_address",
        "branch",
        "authority_directors_detail",
        "audit_firm",
        "licensed_auditor_name",
        "auditor_license_no",
        "fiscal_year_start",
        "fiscal_year_end",
        "auditor_national_id",
        "accountant_firm",
        "accountant_name",
        "accountant_national_id",
        "vat_issued_on",
        "id_type",
        "full_name",
        "national_id",
        "passport_no",
        "contact_address",
        "contact_number",
        "contact_email",
      ];
      fields.forEach((key) => {
        if (
          this.form[key] !== null &&
          this.form[key] !== undefined &&
          this.form[key] !== ""
        ) {
          fd.append(key, this.form[key]);
        }
      });

      fd.append(
        "registered_capital",
        parseFloat(this.form.registered_capital) || 0,
      );
      fd.append("number_of_shares", parseInt(this.form.number_of_shares) || 0);
      fd.append(
        "par_value_per_share",
        parseFloat(this.form.par_value_per_share) || 0,
      );
      fd.append("paid_up_capital", parseFloat(this.form.paid_up_capital) || 0);
      fd.append("user_update", user_id);
      fd.append(
        "is_foreign_business",
        this.form.is_foreign_business ? "true" : "false",
      );
      fd.append("shareholders", JSON.stringify(this.form.shareholders));
      fd.append("directors", JSON.stringify(this.form.directors));

      // ── File handling (⭐ เปลี่ยนเป็นหลายไฟล์) ──
      // ไฟล์เดิมถูกลบทันทีผ่าน API แล้ว (deleteExistingForeignBusinessFile)
      // ตรงนี้แค่ส่งไฟล์ใหม่ที่ผู้ใช้เพิ่มเข้ามา พร้อมแจ้งจำนวนไฟล์ของแต่ละประเภท
      fd.append("fbl_count", String(this.form.fbl_new_files.length));
      fd.append("fbc_count", String(this.form.fbc_new_files.length));
      this.form.fbl_new_files.forEach((file) => {
        fd.append("file", file);
      });
      this.form.fbc_new_files.forEach((file) => {
        fd.append("file", file);
      });

      return fd;
    },

    async saveEdit() {
      // ✅ เพิ่ม: ตรวจสอบฟิลด์บังคับก่อนบันทึก
      if (!this.validateForm()) return;
      this.loadingSave = true;
      this.$showLoader();
      try {
        const fd = this.buildFormData();
        await updateIncorporateMatter(this.matterId, fd);
        this.$hideLoader();
        this.loadingSave = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Success",
          "บันทึกข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          `/incorporate-matter-view/${this.matterId}`,
        );
      } catch (error) {
        this.$hideLoader();
        this.loadingSave = false;
        console.error("Error updating matter:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการบันทึก",
          "text-h5 red--text text-center",
        );
      }
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.$store.state.global_dialog = status;   // ⭐ ต้องเพิ่มบรรทัดนี้
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAddPush = status;
      this.text_color = text_color;
      this.link = link;
      this.$store.state.global_push_dialog = status;   // ⭐ ต้องเพิ่มบรรทัดนี้
    },
  },
};
